import { API_ENDPOINTS } from './api-endpoints';
import { crudFactory } from './curd-factory';
import { HttpClientFront } from './http-client-front';

export const getHistoricalStocks = {
    ...crudFactory(API_ENDPOINTS),
  get:({
    period,   
    ...params 
  }) => {    
    return HttpClientFront.get(`market_insights/${period}`, {
      ...params,      
    });
  }
}

export const getMostActiveStocks = {  
  ...crudFactory(API_ENDPOINTS),  
  all:(params) => {    
    return HttpClientFront.get(`most_active_stocks/${params.period}`, params);
  },
};

export const getTopGainers = {  
  ...crudFactory(API_ENDPOINTS),  
  all:(params) => {    
    return HttpClientFront.get(`top_gainers/${params.period}`, params);
  },
};

export const getTopLosers = {  
  ...crudFactory(API_ENDPOINTS),  
  all:(params) => {    
    return HttpClientFront.get(`top_losers/${params.period}`, params);
  },
};


export const gethomenewsVideos = {  
  ...crudFactory(API_ENDPOINTS),  
  all:(params) => {    
    return HttpClientFront.get(`youtubehome`, params);
  },
};
